import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { BackendApiService } from '../../services/backend-api.service';
import { ProjectContextService } from '../../services/project-context.service';

@Component({
  selector: 'app-create-project-dialog',
  templateUrl: './create-project-dialog.component.html',
  styleUrls: ['./create-project-dialog.component.scss'],
  standalone: false
})
export class CreateProjectDialogComponent {
  projectName: string = '';
  description: string = '';
  isSubmitting: boolean = false;
  errorMessage: string = '';

  constructor(
    public dialogRef: MatDialogRef<CreateProjectDialogComponent>,
    private backendApi: BackendApiService,
    private projectContext: ProjectContextService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  get isValid(): boolean {
    return this.projectName.trim().length >= 2;
  }

  onSubmit(): void {
    if (!this.isValid || this.isSubmitting) return;

    this.isSubmitting = true;
    this.errorMessage = '';

    this.backendApi.createProject({
      name: this.projectName.trim(),
      description: this.description.trim()
    }).subscribe({
      next: (project) => {
        this.isSubmitting = false;
        this.projectContext.setCurrentProject(project);
        this.projectContext.loadUserProjects(true).subscribe();
        this.dialogRef.close(project);
        this.snackBar.open(`Project "${project.name}" created!`, 'Close', { duration: 3500 });
        this.router.navigateByUrl(`/p/${project.id}/t/roadmap`);
      },
      error: (err) => {
        this.isSubmitting = false;
        this.errorMessage = err?.error?.message || 'Failed to create project. Please try again.';
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
